module.exports = __webpack_public_path__ + "static_1793785667647/img/login-bg.a0b0553f.png";